import { render, staticRenderFns } from "./FactorsWithManageAccess.vue?vue&type=template&id=26897b82"
import script from "./FactorsWithManageAccess.vue?vue&type=script&lang=js"
export * from "./FactorsWithManageAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports